module.exports = __webpack_public_path__ + "img/calendar-check.cca1d71b.svg";